import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  infoIcon: {
    color: theme.palette.text.tertiary,
    marginLeft: theme.spacing(1),
  },
  linkOverload: {
    color: `${theme.palette.warning.main} !important`,
  },
  footer: {
    alignItems: 'stretch',
    alignSelf: 'stretch',
    display: 'flex',
    padding: theme.spacing(3),
  },
}));

